
import { defineComponent, reactive, ref } from 'vue';
import TelaPadraoCrud from '@/core/components/TelaPadraoCrud.vue';
import { useCrudBase } from '@/core/composables/CrudBase';
import { ECustomRenderRow } from '@/core/models/AntDesign/IColumn';
import { IOrdenacao } from '@/core/models/Consulta/IOrdenacao';
import { EPermissaoDados } from '@/models/Enumeradores/MeuSistema/Usuarios/EPermissaoDados';
import storeSistema from '@/store/storeSistema';
import ControleProducaoModal from './ControleProducaoModal.vue';
import ServicoControleProducao from '@/servicos/Cadastros/PCP/ServicoControleProducao';

export default defineComponent({
  name: 'ControleProducao',
  components: {
    TelaPadraoCrud,
    ControleProducaoModal,
  },
  setup() {
    const {
      crudBase, preencherEstrutura, exibirModal, sincronizaTelaCrud,
    } = useCrudBase();
    const servicoControleProducao = new ServicoControleProducao();
    const refCrudControleProducao = ref<InstanceType<typeof TelaPadraoCrud>>();

    crudBase.estrutura = preencherEstrutura();
    crudBase.estrutura.apresentarEmpresas = true;
    crudBase.estrutura.verificarCadastroCompartilhado = true;
    crudBase.estrutura.botaoPrincipalAcao = 'Novo';
    crudBase.estrutura.mensagemExclusao = 'Você confirma a exclusão da etapa de produção:';
    crudBase.estrutura.colunasGrade = [
      {
        title: 'Identificador', dataIndex: 'codigo', key: 'Identificador', position: 0, visible: false, ordering: false,
      },
      {
        title: 'Descrição', dataIndex: 'nome', key: 'Nome', position: 1, visible: true, ordering: true, fixed: 'left', ellipsis: true, width: 400, align: 'left', customRenderRow: ECustomRenderRow.LinkAcao,
      },
      {
        title: 'Status', dataIndex: 'ativo', key: 'Ativo', position: 2, visible: true, align: 'left', customRenderRow: ECustomRenderRow.TagAtivo, width: 80,
      },
      {
        title: 'Ações', key: 'acoes', position: 3, visible: true, fixed: 'right', width: 120, align: 'center', customRenderRow: ECustomRenderRow.IconeAcoes,
      },
    ];
    crudBase.estrutura.ordenacaoPadraoGrade.push({ identificador: 'IdentificadorProduto', ordem: 'DESC' } as IOrdenacao);

    const state = reactive({
      exibirImportacaoExcel: false,
    });

    async function sincronizarRegistro(acao: EPermissaoDados, codigoRegistro: number) {
      if (refCrudControleProducao.value !== undefined) {
        await refCrudControleProducao.value.sincronizarRegistro(acao, codigoRegistro);
      }
    }
    return {
      state,
      storeSistema,
      crudBase,
      servicoControleProducao,
      refCrudControleProducao,
      exibirModal,
      sincronizaTelaCrud,
      sincronizarRegistro,
    };
  },
});
